function Scroll() {
	var self = this;
	self.init();
}

Scroll.prototype.init = function() {
	var self = this;
	self.handleScroll();
};

Scroll.prototype.handleScroll = function() {
	var self = this;

	// $(window).on('wheel scroll', function(e) {
				
	// 	if (typeof e.originalEvent.deltaY !== 'undefined' && e.originalEvent.deltaY < 0) {
	// 		$('body').removeClass('-scrolling');
	// 	} else if (typeof e.originalEvent.deltaY !== 'undefined' && e.originalEvent.deltaY > 0) {
	// 		$('body').addClass('-scrolling');
	// 	}

	// });
};